import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-info-group',
	templateUrl: './info-group.component.html',
	styleUrls: ['./info-group.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class InfoGroupComponent {
	@Input() public readonly layout: string = `inline`;
	@Input() public readonly break: 'top' | 'bottom' | 'both' | 'none' = `none`;
	@Input() public readonly bolding: 'key' | 'value' | 'both' | 'none' = `none`;
	@Input() public readonly matchBreakColor: boolean = false;
	@HostBinding('class') public readonly klassName: string = `qe-info-group`;
	@HostBinding('class.m--vertical') public get isVertical(): boolean {
		return this.layout === `vertical`;
	}
	@HostBinding('class.m--loose') public get isLoose(): boolean {
		return this.layout === `loose`;
	}
	@HostBinding('class.m--break-top') public get breakTop(): boolean {
		return this.break === `top`;
	}
	@HostBinding('class.m--break-bottom') public get breakBottom(): boolean {
		return this.break === `bottom`;
	}
	@HostBinding('class.m--break-both') public get breakBoth(): boolean {
		return this.break === `both`;
	}
	@HostBinding('class.m--match-break-color') public get matchBreak(): boolean {
		return this.matchBreakColor;
	}
	@HostBinding('class.m--bold') public get bolded(): boolean {
		return this.bolding === `both`;
	}
	@HostBinding('class.m--bold-key') public get boldedKey(): boolean {
		return this.bolding === `key`;
	}
	@HostBinding('class.m--bold-value') public get boldedValue(): boolean {
		return this.bolding === `value`;
	}
	@HostBinding('attr.role') public readonly ariaRole: string = `presentation`;

	constructor() { }
}
